import { useState } from 'react';
import { DEFAULT_PRESET, PRESETS, fromInputValue, toInputValue } from './window';

/**
 * WHEN — shared by every report. A preset, then the exact range it set: the
 * inputs are the real control, so they sit beside the shortcuts that fill them.
 */
export function WindowPicker({ from, to, setFrom, setTo }: {
  from: Date; to: Date; setFrom: (d: Date) => void; setTo: (d: Date) => void;
}) {
  // Which preset set the window — remembered rather than recomputed from the
  // clock, which render must not read. Editing either input clears it. The page
  // opens on the last 30 days.
  const [activePreset, setActivePreset] = useState<string | null>(DEFAULT_PRESET);
  const applyPreset = (p: { label: string; hours: number }) => {
    const now = new Date();
    setFrom(new Date(now.getTime() - p.hours * 60 * 60 * 1000));
    setTo(now);
    setActivePreset(p.label);
  };

  return (
    <>
      <div className="sa-ranges">
        {PRESETS.map(p => (
          <button
            key={p.label}
            className={`sa-range${activePreset === p.label ? ' is-active' : ''}`}
            onClick={() => applyPreset(p)}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="sa-datetimes">
        <label>
          <span>From</span>
          <input
            type="datetime-local"
            value={toInputValue(from)}
            onChange={e => { const d = fromInputValue(e.target.value); if (d) { setFrom(d); setActivePreset(null); } }}
          />
        </label>
        <label>
          <span>To</span>
          <input
            type="datetime-local"
            value={toInputValue(to)}
            onChange={e => { const d = fromInputValue(e.target.value); if (d) { setTo(d); setActivePreset(null); } }}
          />
        </label>
      </div>
    </>
  );
}
